import { FC } from 'react';
import { Form } from 'react-final-form';
import theme from 'config/theme';
import { Row } from 'components/Row';
import { Link } from 'components/Link';
import Spacing from 'components/Spacing';
import { BodySmall, Eyebrow } from 'components/Typography';
import { ToggleField } from 'components/FinalForm/ToggleField';
import { DonationTotal } from 'components/Slate/DonationAmount/DonationTotal';
import { noop } from 'helpers/utils';
import { GradientBorderCard } from '../GradientBorderCard';
import { InnerGradientBox, ItemTitle, StyledButton, Content } from './styled';

interface Props {
  tabPressed: string | number;
  setTabPressed: (val: string) => void;
  donationAmounts: number[];
  selectedDonationAmount: number | undefined;
  setSelectedDonationAmount: (val: number | undefined) => void;
  buttonText: string;
  isGradientBox?: boolean;
  handleSubmit: () => void;
  keyCard: number;
  borderType: 'full' | 'top';
  tabIssuesOptions: { label: string; value: string }[];
  eyebrowText?: string;
  singleRowDesktop?: boolean;
}

export const DonationCard: FC<Props> = ({
  tabPressed,
  setTabPressed,
  donationAmounts,
  selectedDonationAmount,
  setSelectedDonationAmount,
  buttonText,
  handleSubmit,
  keyCard,
  borderType,
  tabIssuesOptions,
  eyebrowText,
  singleRowDesktop = false,
}) => {
  const CardContent = (
    <>
      <Content $textAlign="center">
        <ItemTitle>Start Your Monthly Donation</ItemTitle>
        <Spacing $size={16} />
        {tabPressed !== 'infra' && (
          <>
            <Eyebrow $color={theme.colors.inkBlue}>{eyebrowText || 'Select your Issue:'}</Eyebrow>
            <Spacing $size={8} />
            <Form
              onSubmit={noop}
              initialValues={{
                tabIssues: tabPressed,
                toggleIssue1: tabPressed,
                toggleIssue2: tabPressed,
              }}
              render={() => (
                <>
                  {/* <HiddenContainer $showInDesktop={true}> */}
                  <Row $justifyContent="center">
                    {tabIssuesOptions.map((item, index) => (
                      <ToggleField
                        key={index}
                        name={`toggleIssue${keyCard}`}
                        value={item.value}
                        onChange={e => setTabPressed(e.target.value)}
                      >
                        <BodySmall $color="inherit">{item.label}</BodySmall>
                      </ToggleField>
                    ))}
                  </Row>
                  {/* </HiddenContainer> */}
                  {/* <HiddenContainer $showInDesktop={false}>
                    <SelectField
                      name="tabIssues"
                      options={tabIssuesOptions}
                      validate={required}
                      onChange={setTabPressed}
                    />
                  </HiddenContainer> */}
                </>
              )}
            />
            <Spacing $size={4} />
          </>
        )}
        <DonationTotal
          fromIssues
          donationAmounts={donationAmounts}
          selectedDonationAmount={selectedDonationAmount}
          setSelectedDonationAmount={setSelectedDonationAmount}
          label="Select your monthly contribution amount:"
          donationButtonsSingleRowDesktop={singleRowDesktop}
        >
          <>
            <Spacing $size={16} />
            <StyledButton onClick={handleSubmit}>{buttonText}</StyledButton>
          </>
        </DonationTotal>
      </Content>
      <div className="contact-us-container">
        <span className="body-small-text color-inkBlue">
          Have questions? Contact us for support{' '}
        </span>
        <Link
          to="/contact"
          target="_blank"
          $color={theme.colors.inkBlue}
          aria-label="Contact us for support (opens in a new tab)"
        >
          here.
        </Link>
      </div>
    </>
  );

  return (
    <GradientBorderCard borderType={borderType}>
      {borderType === 'full' ? (
        <InnerGradientBox>{CardContent}</InnerGradientBox>
      ) : (
        <>{CardContent}</>
      )}
    </GradientBorderCard>
  );
};
